module.exports = __webpack_public_path__ + "img/question.1282a5ae.jpg";